angular.module('lsnBase.deprecated.models')
  .factory('RiskModel', ['LsnRiskModelV1',
    function(LsnRiskModelV1) {
      return LsnRiskModelV1;
    }
  ]);